module.exports = __webpack_public_path__ + "img/fbc.5059e55d.png";